import React from 'react';
import {contentURL} from "src/utilities/utilityFunctions";

const textBoxStyle = { width:400,height:350,marginTop:-350,color:"white",fontFamily:"Comic Sans MS",fontSize:"28pt"};

const textStyle  =   { lineHeight:"1",maxWidth:400,textAlign:"center",marginTop:"175px",
                        transform:"translateY(-50%)",overflowWrap: "break-word",
                        wordWrap: "break-word",hyphens: "auto",
                        textShadow:" 3px 3px 2px rgba(0, 0, 0, 1)"
                    };



const Boom = (props) => {
    const top  = props.top ? props.top : 25;
    const left = props.left ? props.left : 63;
    return (
        <div className="ls-l boomTest" data-ls="offsetxin:0;delayin:250;scalexin:3;scaleyin:3;offsetxout:0;parallaxlevel:1;" style={{width:400,height:350,top:top,left:left}}>
            <div style={{transform:"rotate(-21deg)"}}>
                <img src={contentURL() +  "/site/images/layerslider-gallery-tn/boom.png"} alt=""/>
                <div style={textBoxStyle}>
                    <div style={textStyle}>{props.text}</div>
                </div>
            </div>
        </div>
    )
};

export default Boom;
